<template>
	<!--停止加载-->
	<div class='listTail' v-if='!isLoading'>
		<!--尚未加载完毕-->
		<div v-if='!noMore' class='singleHint'>
			下拉加载更多
		</div>
		
		<!--全部加载完毕-->
		<div v-else>
			<div v-if="overZero" class='singleHint'>
				没有更多数据
			</div>

			<!--搜索不到-->
			<div v-else>
				<!--提示信息-->
				<div class='findNothing' >
					<img :src="'../../static/components/loadListTail/'+ mainIcon + '.png'" />
					<div class='hint'>{{mainTitle}}</div>
					<div class='contact' v-if='showContact'>
						我们正在积极开拓项目中，如果您或身边朋友有加盟意向，可拨打
						<a href='tel:4006-998-998'>4006-998-998转6</a>了解更多加盟信息。
					</div>
					<div v-if='extendBtn' class='extendBtn' @click.stop='clickBtn'>
						{{btnText}}
					</div>
				</div>

				<!--空列表拓展-->
				<div v-if='showExtend' class='nothingExtend'>
					<div class='title'>
						<img src='../../static/components/loadListTail/title_bg_left.png'>
						<img class='icon' :src="'../../static/components/loadListTail/' + subIcon + '.png'"/>
						{{subTitle}}
						<img src='../../static/components/loadListTail/title_bg_right.png'>
					</div>

					<!--广告列表-->
					<div v-if='listType == "ad"' class='adList'>
						<div class='item'  v-for='ad in adList'>
							<img :src="'../../static/components/loadListTail/ad_' + ad.icon + '.png'" />
							<div class='content'>
								<div class='subTitle'>{{ad.title}}</div>
								<div>{{ad.description}}</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
			//广告列表
			adList:[
				{
					//标题
					title:'下载APP',
					//描述
					description:'APP首次登录送￥100代金券',
					//图片
					icon:'down'
				},
				{
					title:'智惠储值',
					description:'充1000送1000K币+100元代金券',
					icon:'recharge'
				},
				{
					title:'住格林，点评双享',
					description:'享K币，享延时退房',
					icon:'comment'
				},
			]
    }
  },
	props: {
		//是否展示列表
		showExtend:{
			type: Boolean,
			default: false
		},
		mainTitle:{
      type: String,
      default: '无内容'
		},
		mainIcon:{
			type: String,
			default: 'noHotel'
		},
    subTitle: {
      type: String,
      default: '为您推荐'
    },
		subIcon:{
			type: String,
			default: 'good'
		},
		//列表正在加载中
		isLoading:{
			type: Boolean,
			default: false
		},
		//列表没有更多数据
		noMore:{
			type: Boolean,
			default: true
		},
		//列表至少包含一项
		overZero:{
			type: Boolean,
			default: true
		},
		//显示联系方式
		showContact:{
			type: Boolean,
			default: false
		},
		//显示按钮
		extendBtn:{
			type: Boolean,
			default: false
    },
    btnText:{
			type: String,
			default: '去首页逛逛'
    },
		//列表类型
		listType:{
			type: String,
			default: 'ad'
		}
  },
	methods: {
		clickBtn(){
      this.$emit('btnHandler')
		}
	},
}
</script>

<style lang="less" scoped>
	@import "../assets/theme.less";
	@import "../assets/common.less";
	//简单提示
	.singleHint{
		text-align:center;
		line-height:0.8rem
	}
	//找不到酒店
	.findNothing{
		text-align:center;
		height:auto;
		padding:0.8rem 0;
		img{
			width:1.3rem;
		}
		.hint{
			width:20em;
			line-height:0.36rem;
			font-size:0.28rem;
			margin:0.3rem auto;
		}
		.contact{
			width:6.26rem;
			height:auto;
			margin:0 auto;
			border:1px solid #efefef;
			font-size:0.24rem;
			line-height:0.36rem;
			padding:0.12rem 0;
			a{
				color:#ff8f3c;
			}
		}
	}
	.nothingExtend{
		padding:0 0.2rem;
		.title{
			.icon{
				height:0.8em;
				position:relative;
				top:0px;
			}
			text-align:center;
			color:@primaryColor;
			padding:1em;
			border-bottom:1px solid #dddddd;
		}
	}
	//镂空按钮
	.extendBtn{
    display: inline-block;
    border:1px solid @primaryColor;
    padding: 3px 6px;
		color:@primaryColor;
		margin:0 auto;
		border-radius:4px;
	}
	//广告列表
	.adList{
		.item{
			width:100%;
			overflow:hidden;
			img{
				height:1.5rem;
			}
			.content{
				.subTitle{
					width:5rem;
					color:#333333;
					font-size:0.3rem;
					line-height:2em;
				}
				color:#999999;
				flex-wrap:wrap;
				display:flex;
				text-align:left;
				margin:auto 1em;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// loadListTail.vue?d09e522c